import React, { useRef, useEffect } from 'react';

import { useSelector } from 'react-redux';
import { STREAM, FORM_NAME, STREAM_ERROR } from './fields';
import { getFormValues } from 'redux-form';
import { StreamError } from './stream-error';

export const WebcamMirror = () => {
  const { [STREAM]: stream, [STREAM_ERROR]: streamError } = useSelector(getFormValues(FORM_NAME));

  const video = useRef();
  useEffect(() => {
    if (stream) {
      video.current.srcObject = stream;
    }
  }, [stream]);

  return (
    <div className="ct-webcam-mirror">
      {!streamError ? (
        <video ref={video} id="webcam-mirror" muted autoPlay playsInline className="ct-webcam-video"></video>
      ) : (
        <div className="ct-mediastream-error">
          <StreamError />
        </div>
      )}
    </div>
  );
};
